import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/views/layout/index'

Vue.use(Router)

/**
 * hidden: 是否显示在左侧菜单
 */

// 通用路由
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true }
]

export default new Router({
  routes: constantRouterMap
})

// 首页模板
export const dashboardRoute = {
  system: {
    path: '',
    component: Layout,
    meta: { title: '首页', icon: 'dashboard' },
    children: []
  },
  empty: {
    path: '',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/dashboard/empty'),
        meta: { title: '首页', icon: 'dashboard' }
      }
    ]
  }
}

export const headerServiceMap = [
  // {
  //   path: '/members',
  //   component: Layout,
  //   children: [
  //     {
  //       id: '58',
  //       path: 'index',
  //       component: () => import('@/views/members/index'),
  //       meta: { title: '用户管理', icon: 'members' }
  //     }
  //   ]
  // },
  {
    path: '/categories',
    component: Layout,
    children: [
      {
        id: '58',
        path: 'index',
        component: () => import('@/views/categories/index'),
        meta: { title: '分类', icon: 'mall' }
      }
    ]
  },
  {
    path: '/links',
    component: Layout,
    children: [
      {
        id: '58',
        path: 'index',
        component: () => import('@/views/links/index'),
        meta: { title: '友情链接', icon: 'mall' }
      }
    ]
  },
  {
    path: '/content',
    component: Layout,
    meta: { title: '内容', icon: 'orders' },
    children: [
      {
        id: '58',
        path: 'tools',
        component: () => import('@/views/content/index'),
        meta: { title: '工具' }
      },
      {
        id: '58',
        path: 'learning',
        component: () => import('@/views/content/learning'),
        meta: { title: '学习' }
      }
    ]
  },
  {
    path: '/submit',
    component: Layout,
    children: [
      {
        id: '58',
        path: 'index',
        component: () => import('@/views/submit/index'),
        meta: { title: '提交', icon: 'mall' }
      }
    ]
  }
]

export const footerServiceMap = [
  {
    name: 'setting',
    path: '/setting',
    component: Layout,
    meta: { title: '系统管理', icon: 'setting' },
    children: [
      {
        id: '58',
        path: 'params',
        component: () => import('@/views/setting/index'),
        meta: { title: '参数管理' }
      }
    ]
  }
  // {
  //   name: 'permission',
  //   path: '/permission',
  //   component: Layout,
  //   meta: { title: '权限', icon: 'permission' },
  //   children: [
  //     {
  //       id: '106',
  //       path: 'admin',
  //       component: () => import('@/views/system/admin'),
  //       name: 'system-admin',
  //       meta: { title: '管理用户' }
  //     },
  //     {
  //       id: '118',
  //       path: 'role',
  //       component: () => import('@/views/system/role'),
  //       name: 'system-role',
  //       meta: { title: '角色权限' }
  //     }
  //   ]
  // }
]
